import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-stat-card',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="stat-card">
      <div class="icon-wrap" [style.background]="color + '1a'" [style.color]="color">
        <mat-icon>{{ icon }}</mat-icon>
      </div>
      <div class="content">
        <div class="label">{{ label }}</div>
        <div class="value">
          {{ value }}<span class="suffix" *ngIf="suffix">{{ suffix }}</span>
        </div>
        <div class="sub" *ngIf="sub">{{ sub }}</div>
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [`
    .stat-card {
      background: #1c2128; border: 1px solid #21262d; border-radius: 10px;
      padding: 18px 20px; display: flex; align-items: flex-start; gap: 14px;
    }
    .icon-wrap {
      width: 40px; height: 40px; border-radius: 6px; flex-shrink: 0;
      display: flex; align-items: center; justify-content: center;
    }
    .icon-wrap mat-icon { font-size: 20px; width: 20px; height: 20px; }
    .content { flex: 1; min-width: 0; }
    .label {
      font-size: 10px; color: #6e7681; font-weight: 600;
      text-transform: uppercase; letter-spacing: .06em; margin-bottom: 5px;
    }
    .value {
      font-size: 24px; font-weight: 700; letter-spacing: -.03em; line-height: 1;
    }
    .suffix { font-size: 14px; color: #6e7681; font-weight: 500; }
    .sub { font-size: 12px; color: #6e7681; margin-top: 5px; }
  `],
})
export class StatCardComponent {
  @Input() icon = '';
  @Input() color = '#00c1a3';
  @Input() label = '';
  @Input() value: string | number = '';
  @Input() suffix = '';
  @Input() sub = '';
}
